"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVersionSupported = void 0;
function isVersionSupported(minVersion, currentVersion) {
    var splittedMinVersion = minVersion.split(".");
    var splittedCurrentVersion = currentVersion.split(".");
    for (var i = 0; i < splittedMinVersion.length; i++) {
        var minVersionNumber = parseInt(splittedMinVersion[i]);
        var currentVersionNumber = parseInt(splittedCurrentVersion[i]) || 0;
        if (currentVersionNumber !== minVersionNumber) {
            return currentVersionNumber >= minVersionNumber;
        }
    }
    return true;
}
exports.isVersionSupported = isVersionSupported;
